var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qrimg && _vm.tenantPrefrences.qrCodeSupport)?_c('div',{staticClass:"p-2 px-0"},[_c('img',{staticStyle:{"border":"1px solid white"},attrs:{"src":_vm.qrimg}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }